import api from './api'

export const videoService = {
  // Get all videos
  async getVideos(videoType = null) {
    const params = videoType ? { video_type: videoType } : {}
    const response = await api.get('/videos/', { params })
    return response.data
  },

  // Get featured videos
  async getFeaturedVideos() {
    const response = await api.get('/videos/featured')
    return response.data
  },

  // Get a specific video
  async getVideo(id) {
    const response = await api.get(`/videos/${id}`)
    return response.data
  },

  // Create a new video (admin)
  async createVideo(data) {
    const response = await api.post('/videos/', data)
    return response.data
  },

  // Update a video (admin)
  async updateVideo(id, data) {
    const response = await api.put(`/videos/${id}`, data)
    return response.data
  },

  // Delete a video (admin)
  async deleteVideo(id) {
    const response = await api.delete(`/videos/${id}`)
    return response.data
  }
}
